import Icon from "components/Icon"
import { Column, Row } from "components/Layout"
import Loader from "components/Loader"
import { AnimatePresence, motion } from "framer-motion"
import { useEffect, useState } from "react"
import colors from "styles/colors"
import texts from "styles/texts"
import css from "./PlayableContainer.module.scss"

const PlayableContainer = ({ selectedGame, setSelectedGame }) => {
  const [iframeLoaded, setIframeLoaded] = useState(false)
  const [openGameTime, setOpenGameTime] = useState(null)

  useEffect(() => {
    if (selectedGame) {
      setOpenGameTime(new Date())
    } else if (openGameTime) {
      const event_duration = new Date() - openGameTime
    }
  }, [selectedGame])

  //
  useEffect(() => {
    if (selectedGame && iframeLoaded) {
      const event_duration = new Date() - openGameTime
      setOpenGameTime(new Date())
    }
  }, [selectedGame, iframeLoaded])

  function handleOnClose() {
    setSelectedGame(null)
    setIframeLoaded(false)
  }

  if (!selectedGame) return null

  return (
    <Column className={css.playableContainer}>
      <Row style={{ background: colors.backgroundDark }} padding={[10, 20]} gap={10} align="m">
        <Icon name="arrow-left" size={24} onClick={handleOnClose} />
        <div style={{ font: texts.ctaLarge, color: colors.textWhite, marginBottom: 1 }}>{selectedGame.title}</div>
      </Row>

      <div style={{ flex: 1, position: 'relative' }}>
        <AnimatePresence>
          {!iframeLoaded && <motion.div
            initial={{ opacity: 0, }}
            animate={{ opacity: 1, }}
            exit={{ opacity: 0, }}
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: "absolute", width: '100%', height: '100%' }}
          >
            <Loader />
          </motion.div>}
        </AnimatePresence>

        <iframe
          title="game"
          src={selectedGame.url}
          className={css.gameIframe}
          referrerPolicy="no-referrer"
          style={{
            opacity: iframeLoaded ? 1 : 0,
          }}
          onLoad={() => setIframeLoaded(true)}
        />
      </div>
    </Column>
  )
}

export default PlayableContainer
